import React from 'react'

import { Link, SectionContainer, Text } from '@vividseats/vivid-ui-kit'
import NextLink from 'next/link'

import { LEGAL_LINKS } from '@/constants'

import styles from './styles.module.scss'

const ModalLinks: React.FC = () => {
    return (
        <SectionContainer className={styles.modalLinks} fluid>
            {LEGAL_LINKS.map(({ to, label }, i) => {
                return (
                    <React.Fragment key={`${i}-${label}`}>
                        <Link LinkComponent={NextLink} className={styles.link} href={to} target="_blank">
                            <Text as="span" size="sm" weight="regular">
                                {label}
                            </Text>
                        </Link>
                        {i !== LEGAL_LINKS.length - 1 && '|'}
                    </React.Fragment>
                )
            })}
        </SectionContainer>
    )
}

export default ModalLinks
